{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2016                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCToolBarPopup;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCPopup, WEBLib.TMSFNCToolBar, WEBLib.TMSFNCTypes
  {$IFDEF FMXLIB}
  ,FMX.Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : first release

type
  TTMSFNCCustomToolBarPopup = class;

  TTMSFNCToolBarPopupButton = class(TCollectionItem)
  private
    FOwner: TTMSFNCCustomToolBarPopup;
    FButton: TTMSFNCToolBarButton;
    FText: String;
    FDataBoolean: Boolean;
    FTag: Integer;
    FDataString: String;
    FDataObject: TObject;
    FDataInteger: NativeInt;
    FWidth: Single;
    FHeight: Single;
    FEnabled: Boolean;
    FVisible: Boolean;
    FTop: Single;
    FLeft: Single;
    FLastElement: Boolean;
    FBitmap: TTMSFNCBitmap;
    FDataPointer: Pointer;
    procedure SetText(const Value: string);
    procedure SetHeight(const Value: Single);
    procedure SetWidth(const Value: Single);
    function IsHeightStored: Boolean;
    function IsWidthStored: Boolean;
    procedure SetEnabled(const Value: Boolean);
    procedure SetVisible(const Value: Boolean);
    function IsLeftStored: Boolean;
    function IsTopStored: Boolean;
    procedure SetLeft(const Value: Single);
    procedure SetTop(const Value: Single);
    procedure SetLastElement(const Value: Boolean);
    procedure SetBitmap(const Value: TTMSFNCBitmap);
  protected
    procedure BitmapChanged(Sender: TObject);
  public
    constructor Create(ACollection: TCollection); override;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
    property Button: TTMSFNCToolBarButton read FButton;
    property DataPointer: Pointer read FDataPointer write FDataPointer;
    property DataBoolean: Boolean read FDataBoolean write FDataBoolean;
    property DataObject: TObject read FDataObject write FDataObject;
    property DataString: String read FDataString write FDataString;
    property DataInteger: NativeInt read FDataInteger write FDataInteger;
  published
    property Text: String read FText write SetText;
    property Tag: Integer read FTag write FTag;
    property Left: Single read FLeft write SetLeft stored IsLeftStored nodefault;
    property Top: Single read FTop write SetTop stored IsTopStored nodefault;
    property Width: Single read FWidth write SetWidth stored IsWidthStored nodefault;
    property Height: Single read FHeight write SetHeight stored IsHeightStored nodefault;
    property Enabled: Boolean read FEnabled write SetEnabled default True;
    property Visible: Boolean read FVisible write SetVisible default True;
    property LastElement: Boolean read FLastElement write SetLastElement default False;
    property Bitmap: TTMSFNCBitmap read FBitmap write SetBitmap;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCToolBarPopupButtons = class(TTMSFNCOwnedCollection)
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCToolBarPopupButtons = class({$IFDEF LCLLIB}specialize {$ENDIF}TTMSFNCOwnedCollection<TTMSFNCToolBarPopupButton>)
  {$ENDIF}
  private
    FOwner: TTMSFNCCustomToolBarPopup;
    function GetItem(Index: Integer): TTMSFNCToolBarPopupButton;
    procedure SetItem(Index: Integer; const Value: TTMSFNCToolBarPopupButton);
  protected
    function CreateItemClass: TCollectionItemClass; virtual;
    function GetOwner: TPersistent; override;
  public
    constructor Create(AOwner: TTMSFNCCustomToolBarPopup); virtual;
    property Items[Index: Integer]: TTMSFNCToolBarPopupButton read GetItem write SetItem; default;
    function Add: TTMSFNCToolBarPopupButton;
    function Insert(Index: Integer): TTMSFNCToolBarPopupButton;
  end;

  TTMSFNCToolBarPopupButtonClickEvent = procedure(Sender: TObject; AButton: TTMSFNCToolBarPopupButton) of object;

  TTMSFNCCustomToolBarPopup = class(TTMSFNCCustomNonFocusablePopup)
  private
    FActivate: Boolean;
    FToolBar: TTMSFNCToolBar;
    FButtons: TTMSFNCToolBarPopupButtons;
    FButtonClick: TTMSFNCToolBarPopupButtonClickEvent;
    FOnDeactivate: TNotifyEvent;
    FOnActivate: TNotifyEvent;
    procedure SetButtons(const Value: TTMSFNCToolBarPopupButtons);
    function GetAutoAlign: Boolean;
    procedure SetAutoAlign(const Value: Boolean);
    function GetDragGrip: Boolean;
    procedure SetDragGrip(const Value: Boolean);
  protected
    function GetVersion: String; override;
    function CreateToolBar: TTMSFNCToolBar; virtual;
    function FindPopupButton(AButton: TTMSFNCToolBarButton): TTMSFNCToolBarPopupButton; virtual;
    function GetInstance: NativeUInt; override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure UpdateControls(Sender: TObject);
    procedure UpdateToolBar; virtual;
    procedure PrepareToolBar; virtual;
    procedure ActivatePopup;
    procedure DeactivatePopup;
    procedure DoClosePopup; override;
    procedure ToolBarClick(Sender: TObject);
    procedure ToolBarButtonClick(Sender: TObject);
    procedure DoDragGripMoving(Sender: TObject; ADeltaX: Double; ADeltaY: Double); virtual;
    property Buttons: TTMSFNCToolBarPopupButtons read FButtons write SetButtons;
    property OnButtonClick: TTMSFNCToolBarPopupButtonClickEvent read FButtonClick write FButtonClick;
    property AutoAlign: Boolean read GetAutoAlign write SetAutoAlign default True;
    property OnActivate: TNotifyEvent read FOnActivate write FOnActivate;
    property OnDeactivate: TNotifyEvent read FOnDeactivate write FOnDeactivate;
    property DragGrip: Boolean read GetDragGrip write SetDragGrip default False;
  public
    constructor Create(AOwner: TComponent); override;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
    procedure Activate; virtual;
    procedure Deactivate; virtual;
    function DropDownActive: Boolean; virtual;
    function Activated: Boolean;
    property ToolBar: TTMSFNCToolBar read FToolBar;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatforms)]
  {$ENDIF}
  TTMSFNCToolBarPopup = class(TTMSFNCCustomToolBarPopup)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property AdaptToStyle;
    property OnButtonClick;
    property AutoAlign;
    property Buttons;
    property Placement;
    property PlacementRectangle;
    property PlacementControl;
    property OnActivate;
    property OnDeactivate;
    property Version;
    property DragGrip;
  end;

implementation

uses
  WEBLib.Forms, WEBLib.TMSFNCUtils
  {$IFNDEF LCLLIB}
  ,Types
  {$ENDIF}
  ;

{$R 'TMSFNCToolBarPopup.res'}

type
  TTMSFNCToolBarOpen = class(TTMSFNCToolBar);

{ TTMSFNCCustomToolBarPopup }

constructor TTMSFNCCustomToolBarPopup.Create(AOwner: TComponent);
begin
  inherited;
  Placement := ppMouse;
  FButtons := TTMSFNCToolBarPopupButtons.Create(Self);
  FToolBar := CreateToolBar;
  if not (csDesigning in ComponentState) then
    FToolBar.Parent := Self;
  FToolBar.AutoAlign := True;
  FToolBar.OnClick := ToolBarClick;
  FToolBar.TabStop := False;
  FToolBar.AllowFocus := False;
  FToolBar.OptionsMenu.ShowButton := False;
  FToolBar.Appearance.DragGrip := False;
  FToolBar.OnDragGripMoving := DoDragGripMoving;
  FToolBar.AutoMoveToolBar := False;
  TTMSFNCToolBarOpen(FToolBar).OnUpdateControls := UpdateControls;
  ContentControl := FToolBar;
end;

function TTMSFNCCustomToolBarPopup.CreateToolBar: TTMSFNCToolBar;
begin
  Result := TTMSFNCToolBar.Create(Self)
end;

destructor TTMSFNCCustomToolBarPopup.Destroy;
begin
  FButtons.Free;
  inherited;
end;

procedure TTMSFNCCustomToolBarPopup.DoClosePopup;
begin
  inherited;
  DestroyPopupForm;
end;

procedure TTMSFNCCustomToolBarPopup.DoDragGripMoving(Sender: TObject; ADeltaX,
  ADeltaY: Double);
begin
  if Assigned(PopupForm) then
  begin
    PopupForm.Left := PopupForm.Left - Round(ADeltaX);
    PopupForm.Top := PopupForm.Top - Round(ADeltaY);
  end;
end;

function TTMSFNCCustomToolBarPopup.DropDownActive: Boolean;
begin
  Result := False;
  if Assigned(ToolBar) then
    Result := ToolBar.DropDownActive;
end;

function TTMSFNCCustomToolBarPopup.FindPopupButton(
  AButton: TTMSFNCToolBarButton): TTMSFNCToolBarPopupButton;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to FButtons.Count - 1 do
  begin
    if AButton = FButtons[I].FButton then
    begin
      Result := FButtons[I];
      Break;
    end;
  end;
end;

function TTMSFNCCustomToolBarPopup.GetAutoAlign: Boolean;
begin
  Result := TTMSFNCToolBarOpen(FToolBar).AutoAlign;
end;

function TTMSFNCCustomToolBarPopup.GetDragGrip: Boolean;
begin
  Result := TTMSFNCToolBarOpen(FToolBar).Appearance.DragGrip;
end;

function TTMSFNCCustomToolBarPopup.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCCustomToolBarPopup.GetVersion: String;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCCustomToolBarPopup.PrepareToolBar;
begin
  if Assigned(FToolBar) then
    FToolBar.AdaptToStyle := AdaptToStyle;
end;

procedure TTMSFNCCustomToolBarPopup.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  if Assigned(FToolBar) then
    FToolBar.AdaptToStyle := AdaptToStyle;
end;

procedure TTMSFNCCustomToolBarPopup.SetAutoAlign(const Value: Boolean);
begin
  TTMSFNCToolBarOpen(FToolBar).AutoAlign := Value;
end;

procedure TTMSFNCCustomToolBarPopup.SetButtons(
  const Value: TTMSFNCToolBarPopupButtons);
begin
  FButtons.Assign(Value);
end;

procedure TTMSFNCCustomToolBarPopup.SetDragGrip(const Value: Boolean);
begin
  TTMSFNCToolBarOpen(FToolBar).Appearance.DragGrip := Value;
end;

procedure TTMSFNCCustomToolBarPopup.ActivatePopup;
begin
  DoCreatePopup(False);
end;

procedure TTMSFNCCustomToolBarPopup.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCCustomToolBarPopup then
  begin
    FButtons.Assign((Source as TTMSFNCCustomToolBarPopup).Buttons);
    AutoAlign := (Source as TTMSFNCCustomToolBarPopup).AutoAlign;
    DragGrip := (Source as TTMSFNCCustomToolBarPopup).DragGrip;
  end;
end;

procedure TTMSFNCCustomToolBarPopup.ToolBarButtonClick(Sender: TObject);
begin
  if Assigned(OnButtonClick) then
    OnButtonClick(Self, FindPopupButton((Sender as TTMSFNCToolBarButton)));
  ActivatePreviousWindow;
end;

procedure TTMSFNCCustomToolBarPopup.ToolBarClick(Sender: TObject);
begin
  ActivatePreviousWindow;
end;

procedure TTMSFNCCustomToolBarPopup.UpdateControls(Sender: TObject);
begin
  UpdateToolBar;
end;

procedure TTMSFNCCustomToolBarPopup.UpdateToolBar;
begin
  if (csLoading in ComponentState) or (csDestroying in ComponentState) then
    Exit;

  DropDownWidth := FToolBar.Width;
  DropDownHeight := FToolBar.Height;
  {$IFDEF FMXLIB}
  if Assigned(PopupForm) then
    PopupForm.ApplyPlacement;
  {$ENDIF}
end;

procedure TTMSFNCCustomToolBarPopup.Activate;
var
  {$IFDEF FMXLIB}
  frm: TCommonCustomForm;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  frm: TForm;
  {$ENDIF}
begin
  if Activated then
    Deactivate;

  {$IFNDEF WEBLIB}
  frm := Screen.ActiveForm;
  if not Assigned(frm) then
    frm := Application.MainForm;
  {$ENDIF}

  if Assigned(ToolBar) then
  begin
    ToolBar.Parent := frm;
    ToolBar.Visible := False;
  end;

  PrepareToolBar;
  ActivatePopup;
  UpdateToolBar;
  FActivate := True;
  if Assigned(OnActivate) then
    OnActivate(Self);
end;

function TTMSFNCCustomToolBarPopup.Activated: Boolean;
begin
  Result := HasPopupForm;
end;

procedure TTMSFNCCustomToolBarPopup.Deactivate;
begin
  DeactivatePopup;
  FActivate := False;
  if Assigned(OnDeactivate) then
    OnDeactivate(Self);
end;

procedure TTMSFNCCustomToolBarPopup.DeactivatePopup;
begin
  ClosePopup;
end;

{ TTMSFNCToolBarPopupButton }

procedure TTMSFNCToolBarPopupButton.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCToolBarPopupButton then
  begin
    FText := (Source as TTMSFNCToolBarPopupButton).Text;
    FWidth := (Source as TTMSFNCToolBarPopupButton).Width;
    FHeight := (Source as TTMSFNCToolBarPopupButton).Height;
    FLeft := (Source as TTMSFNCToolBarPopupButton).Left;
    FTop := (Source as TTMSFNCToolBarPopupButton).Top;
    FEnabled := (Source as TTMSFNCToolBarPopupButton).Enabled;
    FVisible := (Source as TTMSFNCToolBarPopupButton).Visible;
    FBitmap.Assign((Source as TTMSFNCToolBarPopupButton).Bitmap);
    FLastElement := (Source as TTMSFNCToolBarPopupButton).LastElement;
  end;
end;

procedure TTMSFNCToolBarPopupButton.BitmapChanged(Sender: TObject);
begin
  if Assigned(FButton) and not IsBitmapEmpty(FBitmap) then
  begin
    FButton.Bitmaps.Clear;
    FButton.Bitmaps.AddBitmap(FBitmap);
  end;

  if Assigned(FOwner) then
    FOwner.UpdateToolBar;
end;

constructor TTMSFNCToolBarPopupButton.Create(ACollection: TCollection);
begin
  inherited;
  if Assigned(Collection) then
    FOwner := (Collection as TTMSFNCToolBarPopupButtons).FOwner;

  FBitmap := TTMSFNCBitmap.Create;
  FBitmap.OnChange := @BitmapChanged;
  FWidth := -1;
  FHeight := -1;
  FTop := -1;
  FLeft := -1;
  FVisible := True;
  FEnabled := True;
  FLastElement := False;

  if Assigned(FOwner) and Assigned(FOwner.FToolBar) then
  begin
    FButton := TTMSFNCToolBarButton.Create(FOwner.FToolBar);
    FButton.TabStop := False;
    FButton.AllowFocus := False;
    FButton.Parent := FOwner.FToolBar;
    FButton.OnClick := FOwner.ToolBarButtonClick;
  end;

  if Assigned(FOwner) then
  begin
    if Assigned(FOwner.FToolBar) then
      FOwner.FToolBar.AddCustomControl(FButton, Index);
    FOwner.UpdateToolBar;
  end;
end;

destructor TTMSFNCToolBarPopupButton.Destroy;
begin
  FBitmap.Free;
  inherited;
  if Assigned(FOwner) then
    FOwner.UpdateToolBar;
end;

function TTMSFNCToolBarPopupButton.IsHeightStored: Boolean;
begin
  Result := Height <> -1;
end;

function TTMSFNCToolBarPopupButton.IsLeftStored: Boolean;
begin
  Result := Left <> -1;
end;

function TTMSFNCToolBarPopupButton.IsTopStored: Boolean;
begin
  Result := Top <> -1;
end;

function TTMSFNCToolBarPopupButton.IsWidthStored: Boolean;
begin
  Result := Width <> -1;
end;

procedure TTMSFNCToolBarPopupButton.SetBitmap(const Value: TTMSFNCBitmap);
begin
  if FBitmap <> Value then
  begin
    FBitmap.Assign(Value);
    if Assigned(FButton) and not IsBitmapEmpty(FBitmap) then
    begin
      FButton.Bitmaps.Clear;
      FButton.Bitmaps.AddBitmap(FBitmap);
    end;

    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetEnabled(const Value: Boolean);
begin
  if FEnabled <> Value then
  begin
    FEnabled := Value;
    if Assigned(FButton) then
      FButton.Enabled := FEnabled;
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetHeight(const Value: Single);
begin
  if FHeight <> Value then
  begin
    FHeight := Value;
    if Assigned(FButton) and (FHeight > -1) then
      FButton.Height := Round(FHeight);
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetLastElement(const Value: Boolean);
begin
  if FLastElement <> Value then
  begin
    FLastElement := Value;
    if Assigned(FButton) then
      FButton.LastElement := FLastElement;
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetLeft(const Value: Single);
begin
  if FLeft <> Value then
  begin
    FLeft := Value;
    if Assigned(FButton) and (FLeft > -1) then
      FButton.Left := Round(FLeft);
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetText(const Value: String);
begin
  if FText <> Value then
  begin
    FText := Value;
    if Assigned(FButton) then
      FButton.Text := FText;
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetTop(const Value: Single);
begin
  if FTop <> Value then
  begin
    FTop := Value;
    if Assigned(FButton) and (FTop > -1) then
      FButton.Top := Round(FTop);
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetVisible(const Value: Boolean);
begin
  if FVisible <> Value then
  begin
    FVisible := Value;
    if Assigned(FButton) then
      FButton.Visible := FVisible;
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

procedure TTMSFNCToolBarPopupButton.SetWidth(const Value: Single);
begin
  if FWidth <> Value then
  begin
    FWidth := Value;
    if Assigned(FButton) and (FWidth > -1) then
      FButton.Width := Round(FWidth);
    if Assigned(FOwner) then
      FOwner.UpdateToolBar;
  end;
end;

{ TTMSFNCToolBarPopupButtons }

function TTMSFNCToolBarPopupButtons.Add: TTMSFNCToolBarPopupButton;
begin
  Result := TTMSFNCToolBarPopupButton(inherited Add);
end;

constructor TTMSFNCToolBarPopupButtons.Create(AOwner: TTMSFNCCustomToolBarPopup);
begin
  inherited Create(AOwner, CreateItemClass);
  FOwner := AOwner;
end;

function TTMSFNCToolBarPopupButtons.CreateItemClass: TCollectionItemClass;
begin
  Result := TTMSFNCToolBarPopupButton;
end;

function TTMSFNCToolBarPopupButtons.GetItem(
  Index: Integer): TTMSFNCToolBarPopupButton;
begin
  Result := TTMSFNCToolBarPopupButton(inherited Items[Index]);
end;

function TTMSFNCToolBarPopupButtons.GetOwner: TPersistent;
begin
  Result := FOwner;
end;

function TTMSFNCToolBarPopupButtons.Insert(
  Index: Integer): TTMSFNCToolBarPopupButton;
begin
  Result := TTMSFNCToolBarPopupButton(inherited Insert(Index));
end;

procedure TTMSFNCToolBarPopupButtons.SetItem(Index: Integer;
  const Value: TTMSFNCToolBarPopupButton);
begin
  inherited Items[Index] := Value;
end;

{ TTMSFNCToolBarPopup }

procedure TTMSFNCToolBarPopup.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarPopup);
end;

end.
